import { render, staticRenderFns } from "./PrimaryGeofence.vue?vue&type=template&id=09b27f8d&scoped=true"
import script from "./PrimaryGeofence.vue?vue&type=script&lang=js"
export * from "./PrimaryGeofence.vue?vue&type=script&lang=js"
import style0 from "./PrimaryGeofence.vue?vue&type=style&index=0&id=09b27f8d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b27f8d",
  null
  
)

export default component.exports